var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.message.content)+"\n  "),_vm._l((_vm.message.files),function(file){return _c('div',{key:file.id},[_c('a',{staticClass:"filedownload",attrs:{"href":file.base64,"download":file.meta.name}},[_c('i',{staticClass:"fa fa-file"},[_vm._v(" "+_vm._s(file.meta.name)+" ")])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c56e39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/chat/AttachmentMessage.vue
// module id = null
// module chunks = 